import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DataModule } from '../keepalive/components/data/data.module';
import { CardTableModule } from '../tools/card-table/card-table.module';
import { SearchableComboboxModule } from '../tools/searchable-combobox/searchable-combobox.module';
import { ToolsModule } from '../tools/tools.module';
import { RelayLineGraphComponent } from './components/graphs/relay-line-graph/relay-line-graph.component';
import { RelayRoutingModule } from './relay-routing.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FiltersModule } from '../tools/filters/filters.module';
import { MatRowComponent } from "../tools/mat-row/mat-row.component";

@NgModule({
    declarations: [RelayLineGraphComponent],
    imports: [
        CommonModule,
        RelayRoutingModule,
        MaterialModule,
        DataModule,
        ToolsModule,
        CardTableModule,
        SearchableComboboxModule,
        MatExpansionModule,
        NgApexchartsModule,
        FiltersModule,
        NgxMaterialTimepickerModule,
        MatRowComponent
    ]
})
export class RelayModule {}
